// SectionHeaderNoPDF.jsx
import React, { useState } from "react";
import { FaShareAlt, FaTimes, FaFileAlt, FaFilePdf } from "react-icons/fa";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaPinterest,
  FaWhatsapp,
  FaEnvelope,
} from "react-icons/fa";

const SectionHeaderDatasheet = ({ title, shareUrl, onPdfClick, generatingPdf }) => {
  const [showOverlay, setShowOverlay] = useState(false);

  // Use provided shareUrl or fall back to current page URL
  const currentUrl = encodeURIComponent(shareUrl || window.location.href);
  const pageTitle = encodeURIComponent(title || "Check this out!");

  const toggleOverlay = () => setShowOverlay(!showOverlay);

  return (
    <>
      {/* Header Section */}
      <div className="flex items-center justify-center text-[#00D084] font-semibold text-xl md:text-2xl mb-4 relative z-10">
        <h2 className="mr-2 text-xl md:text-3xl">{title}</h2>
        <FaShareAlt
          className="text-[#00D084] text-2xl md:text-3xl cursor-pointer ml-2"
          onClick={toggleOverlay}
        />
        <button
          onClick={onPdfClick}
          disabled={generatingPdf}
          className="ml-2 text-[#00D084] hover:text-green-600 text-2xl md:text-3xl cursor-pointer transition-colors disabled:opacity-50"
          title="Download PDF"
        >
          {generatingPdf ? (
            <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-[#00D084]"></div>
          ) : (
            <FaFilePdf />
          )}
        </button>
      </div>

      {/* Fullscreen Overlay */}
      {showOverlay && (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex flex-col items-center justify-center px-4">
          <div className="flex flex-wrap justify-center gap-6 max-w-md w-full">
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF className="text-blue-400 text-2xl md:text-3xl transition-transform hover:scale-110" />
            </a>
            <a
              href={`https://twitter.com/intent/tweet?url=${currentUrl}&text=${pageTitle}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter className="text-sky-400 text-2xl md:text-3xl transition-transform hover:scale-110" />
            </a>
            <a
              href={`https://www.linkedin.com/sharing/share-offsite/?url=${currentUrl}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn className="text-blue-600 text-2xl md:text-3xl transition-transform hover:scale-110" />
            </a>
            <a
              href={`https://pinterest.com/pin/create/button/?url=${currentUrl}&description=${pageTitle}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaPinterest className="text-red-400 text-2xl md:text-3xl transition-transform hover:scale-110" />
            </a>
            <a
              href={`https://wa.me/?text=${pageTitle}%20${currentUrl}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp className="text-green-500 text-2xl md:text-3xl transition-transform hover:scale-110" />
            </a>
            <a
              href={`mailto:?subject=${pageTitle}&body=${currentUrl}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaEnvelope className="text-orange-400 text-2xl md:text-3xl transition-transform hover:scale-110" />
            </a>

            <button
              className="text-white bg-white/10 p-3 rounded-full hover:bg-white hover:text-black transition-all duration-200"
              onClick={toggleOverlay}
            >
              <FaTimes className="text-2xl" />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default SectionHeaderDatasheet;
